import { getUsageRawAPI } from "@/apis/usage-api"
import { aptSearchStore } from "@/routes/select/apt/apt-search-store"
import { toast } from "sonner"
import { create } from "zustand"

export const leakChartStore = create((set, get) => ({
  leakUnits: [],

  pickUnit: null,
  setPickUnit: (pickUnit) => set({ pickUnit }),

  startIndex: 0,
  endIndex: 0,
  startLabel: "-",
  endLabel: "-",

  usageSum: 0,
  leakSum: 0,
  leakRate: 0,

  selectedPeriod: "week",
  setSelectedPeriod: (selectedPeriod) => set({ selectedPeriod }),

  series: [],
  xLabels: [],

  setLeakUnits: (leakUnits) => set({ leakUnits }),

  setRange: (start, end, labels) =>
    set({
      startIndex: start,
      endIndex: end,
      startLabel: labels?.[start] ?? null,
      endLabel: labels?.[end - 1] ?? null
    }),

  setSummary: ({ usage, leak }) =>
    set({
      usageSum: usage,
      leakSum: leak,
      leakRate: usage > 0 ? (leak / usage) * 100 : 0
    }),

  setLeakChart: (usageData, leakData, xLabels) => {
    const usageSeries = {
      color: "#4caefe",
      data: usageData,
      name: "usage"
    }
    const leakSeries = {
      color: "#ED561B",
      data: leakData,
      name: "leakAmount"
    }
    const noleakSeries = {
      color: "#999",
      data: leakData.map((d) => (d > 0 ? null : d)),
      name: "leakAmount"
    }

    set({ series: [usageSeries, leakSeries, noleakSeries], xLabels })
  },

  apiGetLeakChart: async ({ dong, ho, start_date, end_date } = {}) => {
    if (start_date > end_date) return toast.error("기간 설정이 잘못되었습니다.")
    const { sido, kapt_code } = aptSearchStore.getState().pickApt

    const { setLeakChart, setSummary, setRange } = get()

    const result = await getUsageRawAPI({
      sido,
      kapt_code,
      dong,
      ho,
      start_date,
      end_date,
      resource: "water"
    })
    const { x_labels, datasets } = result
    setLeakChart(datasets.usages, datasets.leaks, x_labels)

    const usage = datasets.usages.reduce((a, b) => a + b, 0)
    const leak = datasets.leaks.reduce((a, b) => a + b, 0)

    setSummary({ usage, leak })
    if (!x_labels?.length) return
    setRange(0, x_labels.length, x_labels)
  },

  reset: () => {
    set({
      pickUnit: null,
      selectedPeriod: "week",
      leakUnits: [],
      startIndex: 0,
      endIndex: 0,
      startLabel: "-",
      endLabel: "-",
      usageSum: 0,
      leakSum: 0,
      leakRate: 0,
      userNo: "",
      series: [],
      xLabels: []
    })
  }
}))
